export interface BuyerSidebarReducer {
    isOpen: boolean;
}

const initialState: BuyerSidebarReducer = {
    isOpen: false,
};

const sellerSidebar = (state = initialState, action) => {
    switch (action.type) {
        case 'BUYER_SIDEBAR_SET_IS_OPEN':
            return { ...state, isOpen: action.data };
        case 'BUYER_SIDEBAR_TOGGLE_OPEN':
            return { ...state, isOpen: !state.isOpen };
            

        default:
            return state;
    }
};

export default sellerSidebar;